const returnBadgeVariant = function returnBadgeVariant(element) {
  switch (element.statusStr) {
    case "ZAPRIMLJENO":
      return "success";
    case "PREUZETO":
      return "success";
    case "PRIHVACENO":
      return "success";
    case "ODBACENO":
      return "danger";
    case "OBUSTAVLJENO":
      return "danger";
    case "ODBIJENO":
        return "danger";
    default:
      return "secondary";
      break;
  }
};

export default returnBadgeVariant;
